// src/components/LotusServices.jsx
import React from "react";

const servicesData = [
  {
    title: "Mumbai Outstation Cabs",
    image: "/images/service/1.jpg",
    description:
      "Travel outside Mumbai comfortably with Omshree Cabs. We provide reliable outstation cab services with professional drivers and well-maintained vehicles."
  },
  {
    title: "One-Way & Round Trip Cabs",
    image: "/images/service/2.jpg",
    description:
      "Choose flexible travel options with one-way and round trip cab services. Enjoy affordable pricing and convenient bookings with Omshree Cabs."
  },
  {
    title: "Mumbai Airport Cab Service",
    image: "/images/service/3.jpg",
    description:
      "Get timely airport pickups and drops with Omshree Cabs. We ensure punctual, safe, and stress-free travel to and from Mumbai airport."
  },
  {
    title: "Corporate Cab Services in Mumbai",
    image: "/images/service/4.jpg",
    description:
      "Omshree Cabs offers professional corporate cab services for businesses. Ensure comfortable and reliable transport for your employees and clients."
  },
  {
    title: "Door-to-Door Pickup & Drop",
    image: "/images/service/5.jpg",
    description:
      "Enjoy hassle-free door-to-door cab services with Omshree Cabs. We provide convenient pickup and drop at your preferred location."
  },
  {
    title: "Marriage Event Cab Service",
    image: "/images/service/6.jpg",
    description:
      "Make wedding transportation smooth with Omshree Cabs. We provide reliable and comfortable cabs for guests and event travel."
  },
  {
    title: "Corporate Events Cab Service",
    image: "/images/service/7.jpg",
    description:
      "Ensure seamless transportation for corporate events with Omshree Cabs. We offer organized and dependable cab services for all event needs."
  },
  {
    title: "Cab Service for Picnic in Mumbai",
    image: "/images/service/8.jpg",
    description:
      "Plan a fun picnic with Omshree Cabs. Enjoy safe and comfortable travel for family and group outings in and around Mumbai."
  },
  {
    title: "24x7 Cab Service in Mumbai",
    image: "/images/service/9.jpg",
    description:
      "Omshree Cabs is available round the clock. Book a cab anytime and travel safely with our 24/7 cab services in Mumbai."
  },
  {
    title: "Affordable Taxi Service in Mumbai",
    image: "/images/service/10.jpg",
    description:
      "Get budget-friendly cab services without compromising on comfort. Omshree Cabs offers affordable taxi options for all travelers."
  },
  {
    title: "Online Cab Booking in Mumbai",
    image: "/images/service/11.jpg",
    description:
      "Book your cab easily online with Omshree Cabs. Our simple booking process ensures quick confirmations and hassle-free travel."
  },
  {
    title: "Clean, Hygienic & Well-Maintained Cars",
    image: "/images/service/12.jpg",
    description:
      "Travel with confidence in our clean and sanitized vehicles. Omshree Cabs ensures hygiene and regular maintenance for a safe journey."
  }
];

const Omservice = () => {
  return (

<>

  <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Services</h2>
          </div>
        </div>
      </div>
    </div>


    <section className="services-section py-5">
      <div className="container">
        <div className="text-center mb-5">
        </div>

        <div className="row g-4">
          {servicesData.map((service, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div className="card h-100 border-success shadow-sm">
                <img
                  src={service.image}
                  className="card-img-top"
                  alt={service.title}
                />
                <div className="card-body">
                  <h5 className="card-title text-successs fw-bold">
                    {service.title}
                  </h5>
                  <p className="card-text">{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

</>
  );
};

export default Omservice;
